import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function DrugList(){

  const [pharmviewData, setpharmviewData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchpharmviewData();
  }, []);

  function fetchpharmviewData() {
        setIsLoading(true);
        axios.get(`${baseUrl}pharm-search/?totqty=gt0`)
          .then(response => {
            setpharmviewData(response.data);
            setIsLoading(false);
          })
          .catch(error => {
            console.log(error);
            setIsLoading(false);
          });
  }

    const columns = [
        {field:'id', headerName:'ID',width: 30},
        {field:'product', headerName:'Product', width:220},
        {field:'hsn', headerName:'HSN', width:90},
        {
          field: 'distributor',
          headerName: 'Distributor',
          width: 150,
          renderCell: (params) => {
            return params.row.dist ? params.row.dist.name : 'Unknown';
          },
        },
        {field:'type', headerName:'Type', width:60},
        {field:'schedule', headerName:'Schedule', width:110},

        {field:'batch', headerName:'Batch', width:100},
        {field:'expiry', headerName:'Expiry', width:100},
        {field:'pack', headerName:'Pack', width:10},
        {field:'totqty', headerName:'TQty', width:60},
        {field:'mrp', headerName:'MRP', width:70},
        {field:'sprice', headerName:'S.Price', width:70},
        {field:'sgst', headerName:'SGST', width:30},
        {field:'cgst', headerName:'CGST', width:30},
        {field:'uamount', headerName:'Unit Price', width:80},
        { field: 'action', headerName: 'Action',
          renderCell: (params) => (
              <Link target="_blank" to={`/edit-pharm/${params.row.id}/`} className="btn btn-warning">
                Edit
              </Link>
          ),
        width: 80,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
      ];
    return (
    <section className="container mt-4">
    <div className="row">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
          Drug List - Pharmacy
    </h3>
    {!isLoading && pharmviewData.length > 0 ? (
        <div style={{ height: '100%', width: '100%' }} className="mt-4">
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {pharmviewData}
            columns= {columns}
            pageSize= {10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
            />
        </div>
    ) : (
        <>loading pls wait....</>
    )}
    </div>
    </section>
    )
}

export default DrugList;
